import { NavLink } from "react-router-dom";

export function AccueilPage() {
    return (
        <div className="text-white">
            <div className="flex flex-col items-center gap-10 my-10">
                <NavLink to="/trouver_film" className="py-2 px-5 hover:bg-blue-700 bg-blue-600 rounded-md">Trouver votre film</NavLink>
                <NavLink to="/recommandation_par_genre" className="py-2 px-5 hover:bg-green-700 bg-green-600 rounded-md">Recommandation par Genre</NavLink>
                <NavLink to="/recommandation_par_annee" className="py-2 px-5 hover:bg-orange-700 bg-orange-600 rounded-md">Recommandation par Année</NavLink>
            </div>
        </div>
    )
}